const DownloadOverlayHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return {
      show: false,
    };
  }

  switch (action.type) {
    case 'SHOW_DOWNLOAD_ARROW_OVERLAY':
      return Object.assign({}, state, { show: true });
    case 'HIDE_DOWNLOAD_ARROW_OVERLAY':
      return Object.assign({}, state, { show: false });
    default:
      return state;
  }
};

export default DownloadOverlayHandler;



// WEBPACK FOOTER //
// ./src-react/download-overlay/DownloadOverlayReducer.jsx